import React from 'react';
import { motion } from 'framer-motion';
import '../style.css';
import '../nov.css';

const DigitalDistribution = () => {
  return (
    <section id="digital-distribution" className="bg-white relative overflow-hidden">
      <div className="container mx-auto px-4 lg:px-0 relative z-10 py-8 lg:py-16">
        <div className="w-full text-center max-w-3xl mx-auto">
          <motion.div 
            className="mb-8 mt-4 text-center"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
          >
            <span className="text-sm font-medium badge-gradient text-gray-700 py-3 px-6 rounded-full inline-block uppercase tracking-wide" style={{ fontFamily: 'aesthet-nova' }}>
              Digital Distribution
            </span>
          </motion.div>
          <motion.h1 
            className="text-3xl md:text-6xl lg:text-8xl font-bold mb-8 relative" 
            style={{ fontFamily: 'aesthet-nova', fontWeight: 700 }}
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="flex items-center justify-center gap-2">
              <motion.span 
                style={{ color: 'rgb(70, 52, 135)' }}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                SHARE YOUR MUSIC
              </motion.span>
              <motion.span 
                style={{ '--shimmer-width': '250px' }} 
                className="text-neutral-600/50 animate-shimmer bg-clip-text bg-no-repeat [background-position:0_0] [background-size:var(--shimmer-width)_100%] [transition:background-position_1s_cubic-bezier(.6,.6,0,1)_infinite] bg-gradient-to-r from-neutral-100 via-black/80 via-50% to-neutral-100"
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.4 }}
              >
                WITH THE WORLD
              </motion.span>
            </div>
          </motion.h1>
          <motion.p 
            className="px-4 md:text-xl font-light max-w-[577px] m-auto text-black leading-relaxed" 
            style={{ fontFamily: 'system-ui, Avenir, Helvetica, Arial, sans-serif' }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.5 }}
          >
            With Media Nov, release your music on all major digital platforms like Spotify, Apple Music, Amazon Music, Deezer, and more. Reach global audiences and earn revenue while we protect your rights.
          </motion.p>
        </div>
      </div>
    </section>
  );
};

export default DigitalDistribution;
